// FIX 2026-09-15: en /cart el carrito lateral convive con la propia pagina del
// carrito. Si al cambiar cantidades solo se refresca el panel, la pagina de
// debajo se queda con las cantidades, el total y el aviso de envio viejos, y el
// cliente ve dos cifras distintas a la vez. Devolvemos las secciones del
// template del carrito que esten presentes para refrescarlas tambien.
function seccionesDeLaPaginaDelCarrito(formato) {
  const encontradas = [];
  document.querySelectorAll('[id^="shopify-section-"]').forEach((el) => {
    const id = el.id.replace('shopify-section-', '');
    if (!/(^|_|-)cart-(items|footer)$/.test(id)) return;
    if (formato === 'seccion') {
      // Lo que espera CartItems: id del elemento, seccion a pedir y selector.
      encontradas.push({ id: el.id, section: id, selector: '#' + el.id });
    } else {
      encontradas.push({ id: id, selector: '#' + el.id });
    }
  });
  return encontradas;
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.isOpen = false;
    this.boundClose = this.close.bind(this);

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.boundClose);
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    // Evitar abrir múltiples veces
    if (this.isOpen) return;
    this.isOpen = true;

    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
      // Disparar evento personalizado para que otros componentes sepan que el drawer se abrió
      document.dispatchEvent(new CustomEvent('cart:drawer-opened'));
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.isOpen = false;
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      // Re-bindear el evento del overlay después de actualizar el contenido
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) {
        overlay.removeEventListener('click', this.boundClose);
        overlay.addEventListener('click', this.boundClose);
      }

      // Solo abrir si no está ya abierto
      if (!this.isOpen) {
        this.open();
      } else {
        // Si ya está abierto, solo re-aplicar trapFocus después de actualizar contenido
        removeTrapFocus();
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');

        if (containerToTrapFocusOn) {
          trapFocus(containerToTrapFocusOn, focusElement);
        }

        // Asegurar que overflow-hidden sigue aplicado
        document.body.classList.add('overflow-hidden');
      }
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    const secciones = [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];

    secciones.push(...seccionesDeLaPaginaDelCarrito('selector'));
    return secciones;
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    const secciones = [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
    // Si estamos en /cart, refrescar tambien la pagina que hay debajo.
    secciones.push(...seccionesDeLaPaginaDelCarrito('seccion'));
    return secciones;
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
